/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2022-05-23 10:49:36
 * @LastEditTime: 2022-05-23 18:09:18
 * @LastEditors: 赵大壮
 */
import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './element-variables.scss'

Vue.use(Element)